/*
  Anonymous identifiers for QR-code scan tracking on the public videos page.

  visitorId  localStorage  — stable per device/browser, so repeat scans of the
                             same report collapse into one "unique scan"
  sessionId  sessionStorage — stable per tab, used only to de-duplicate a single
                             visit's events

  Neither is derived from the patient, their report, their IP or their user
  agent, and neither is readable outside this origin. When storage is
  unavailable — private browsing, locked-down iOS, cookies blocked — the id is
  simply absent: the scan still counts towards the total but is reported as
  unattributed rather than guessed at.
*/

const VISITOR_ID_KEY = "er_video_visitor_id"
const SESSION_ID_KEY = "er_video_session_id"

// Also used for playback event and play ids. randomUUID only exists in secure
// contexts, so plain-http LAN testing takes the fallback too.
export const createId = () => {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID()
  // Older Safari: good enough for de-duplication, never used as a secret.
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`
}

const readOrCreate = (storage, key) => {
  try {
    const existing = storage.getItem(key)
    if (existing) return existing

    const created = createId()
    storage.setItem(key, created)
    return created
  } catch {
    return null
  }
}

export const getVisitorId = () =>
  readOrCreate(window.localStorage, VISITOR_ID_KEY)

export const getSessionId = () =>
  readOrCreate(window.sessionStorage, SESSION_ID_KEY)

export const getTrackingIds = () => ({
  visitorId: getVisitorId(),
  sessionId: getSessionId(),
})
